<template>
    <v-container>
        <StoreDialog
            :store-data="currentStore"
            :is-open="storeDialog"
            @on-confirm="confirmSaveStore"
            @on-close="closeStoreDialog"
        />
        <v-row>
            <v-col cols="12">
                <v-card flat>
                    <v-card-title class="pt-0">
                        <v-row align="center">
                            <v-col cols="12" sm="6" md="4">
                                <v-btn
                                    v-if="canCreateStore"
                                    color="secondary"
                                    medium
                                    data-sentry-label="Dodaj magazyn"
                                    @click="createStore()"
                                >
                                    <v-icon left>
                                        mdi-plus
                                    </v-icon>
                                    Dodaj magazyn
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table
                            :headers="headers"
                            :items="stores"
                            :loading="storesLoading"
                            :footer-props="footerProps"
                            :server-items-length="pagination.itemsLength"
                            :mobile-breakpoint="0"
                            :page.sync="pagination.page"
                            name="storesData"
                            class="pa-0"
                            @pagination="updatePagination"
                        >
                            <template #item.name="{item}">
                                {{ item.name }}
                            </template>
                            <template #item.isActive="{item}">
                                <v-icon
                                    v-if="item.isActive"
                                    small
                                    color="success"
                                >
                                    mdi-check
                                </v-icon>
                                <v-icon v-else small color="error">
                                    mdi-close
                                </v-icon>
                            </template>
                            <template #item.actions="{item}">
                                <div class="d-inline-flex">
                                    <v-tooltip :open-delay="tooltipDelay" top>
                                        <template #activator="{on}">
                                            <v-btn
                                                icon
                                                data-sentry-label="Edytuj"
                                                v-on="on"
                                                @click="showStoreDialog(item.id)"
                                            >
                                                <v-icon color="teal">
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edycja</span>
                                    </v-tooltip>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import StoreDialog from './StoreDialog'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import { hasUserPermission } from '@/utils/permissionsHandler'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'StoresList',
    components: {
        StoreDialog,
    },
    mixins: [
        pagination,
        tooltipDelay,
        dateFormatter,
        customFilters,
        dataTableClassSetter
    ],
    data() {
        return {
            storeDialog: false,
            currentStore: {},
            tabs: null,
            headers: [
                {
                    text: 'Nazwa',
                    value: 'name',
                    sortable: false,

                },
                {
                    text: 'Czy aktywny?',
                    value: 'isActive',
                    sortable: false,
                    align: 'center',
                    width: 120
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        stores() {
            return this.$store.state.shipping.configurations.configurations.stores
        },
        storesLoading() {
            return this.$store.state.shipping.configurations.configurations.storesLoading
        },
        canCreateStore() {
            return hasUserPermission('notification_admin_create')
        },
    },
    mounted() {
        this.getStores()
    },
    methods: {
        getStores() {
            this.$store.dispatch('shipping/configurations/getStores', {
                paginate: this.paginate(),
                query: ''
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        createStore() {
            this.storeDialog = true
        },
        showStoreDialog(storeId) {
            this.$store.dispatch('shipping/configurations/getStore', storeId)
                .then(responses => {
                    this.currentStore = responses.data
                    this.storeDialog = true
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        updatePagination(pagination) {
            this.pagination = pagination

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getStores()
            }
            this.clearPaginationPending()
        },
        confirmSaveStore() {
            this.getStores()
        },
        closeStoreDialog() {
            setTimeout(() => {
                this.currentStore = {}
            }, 500)
            this.storeDialog = false
        },
    }
}
</script>